module.exports = __webpack_public_path__ + "img/course.f6030664.svg";